module.exports = __webpack_public_path__ + "img/slotmachine.5aba8010.png";